import { useEffect } from 'react';
import useProductActionsStore from '../../../stores/ProductActionsStore/productActions.store';

export const useProductNotificationHighlight = (isOpen: boolean) => {
  const setNotificationTimerIsValid = useProductActionsStore(
    (state) => state.setNotificationTimerIsValid,
  );

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setNotificationTimerIsValid(true);

    return () => {
      setNotificationTimerIsValid(false);
    };
  }, [isOpen, setNotificationTimerIsValid]);
};
